import {
  Button,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
  Input,
  Textarea,
} from '@/shared/components';
import { type EditBankAddressFormValues } from '../model';
import { useTranslation } from 'react-i18next';
import type { UseFormReturn } from 'react-hook-form';
import { getRequiredLabel } from '@/shared/lib';
import type { SavedBankAddress } from '@/entities/bank-address';

type Props = {
  savedBankAddress: SavedBankAddress;
  form: UseFormReturn<EditBankAddressFormValues>;
  updateAddress: () => Promise<void>;
  deleteAddress: () => Promise<void>;
  isPending: boolean;
};

export const EditBankAddressForm = ({
  savedBankAddress,
  form,
  updateAddress,
  isPending,
  deleteAddress,
}: Props) => {
  const { t } = useTranslation();

  return (
    <Form {...form}>
      <form
        className="flex flex-col gap-[1.6rem]"
        onSubmit={form.handleSubmit(updateAddress)}>
        {savedBankAddress.params.map(param => (
          <Textarea
            key={param.paramId}
            label={param.paramName}
            value={param.paramValue}
            className="p3"
            autoGrow={true}
            disabled
          />
        ))}

        <FormField
          control={form.control}
          name="templateName"
          render={({ field }) => {
            return (
              <FormItem>
                <FormControl>
                  <Input
                    {...field}
                    label={getRequiredLabel(
                      t('savedAddresses.bankAddress.fields.templateNameLabel')
                    )}
                    className="p3"
                    onChange={field.onChange}
                  />
                </FormControl>
                <FormMessage className="px-[1.6rem]" />
              </FormItem>
            );
          }}
        />

        <Button
          size="lg"
          type="submit"
          loading={isPending}
          className="mt-[1.6rem]">
          {t('savedAddresses.bankAddress.editing.buttonText')}
        </Button>

        <Button
          size="lg"
          type="button"
          variant="secondary"
          onClick={deleteAddress}
          disabled={isPending}>
          {t('savedAddresses.bankAddress.deletion.buttonText')}
        </Button>
      </form>
    </Form>
  );
};
